import React, { createContext, useState, useEffect, useContext } from 'react';
import { PFDefaultEvaluation, PFClient } from '@pataflags/sdk-js';

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var PFApplicationContext = createContext({
  client: null,
  evaluation: PFDefaultEvaluation,
  error: null,
  isReady: false
});
var KProvider = function KProvider(props) {
  var _useState = useState(PFDefaultEvaluation),
      _useState2 = _slicedToArray(_useState, 2),
      evaluation = _useState2[0],
      setEvaluation = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      loading = _useState6[0],
      setLoading = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isReady = _useState8[0],
      setIsReady = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      client = _useState10[0],
      setClient = _useState10[1];

  var children = props.children,
      onChanges = props.onChanges,
      onIdentified = props.onIdentified;
  useEffect(function () {
    var _client = PFClient.initialize(props.apiKey, props.user, Object.assign({}, props.options));

    setClient(function () {
      return _client;
    });

    _client.onReady(function () {
      setEvaluation(_client.evaluation());
      setIsReady(true);
    });

    _client.onChanges(function () {
      setEvaluation(_client.evaluation());
      setLoading(false);
      if (onChanges) onChanges();
    });

    _client.onError(setError);

    _client.onIdentified(function () {
      if (onChanges) onIdentified();
    });

    return function () {
      return _client._dispose();
    };
  }, [onChanges, onIdentified, props.apiKey, props.options, props.user]);

  var returnChildren = function returnChildren() {
    return typeof children === "function" ? children({
      isLoading: loading,
      isError: !!error,
      error: error,
      evaluation: evaluation
    }) : React.createElement(React.Fragment, null, children);
  };

  return React.createElement(PFApplicationContext.Provider, {
    value: {
      client: client,
      evaluation: evaluation,
      error: error,
      isReady: isReady
    }
  }, returnChildren());
};

function useEvaluation() {
  var _useContext = useContext(PFApplicationContext),
      client = _useContext.client;

  return client === null || client === void 0 ? void 0 : client.evaluation();
}
function useReleaseToggles() {
  var _useContext2 = useContext(PFApplicationContext),
      client = _useContext2.client;

  return client === null || client === void 0 ? void 0 : client.releaseToggles();
}
function useIsEnabled(releaseToggleKey) {
  var _useContext3 = useContext(PFApplicationContext),
      client = _useContext3.client;

  return client === null || client === void 0 ? void 0 : client.isEnabled(releaseToggleKey);
}
function useRemoteConfigs() {
  var _useContext4 = useContext(PFApplicationContext),
      client = _useContext4.client;

  return client === null || client === void 0 ? void 0 : client.remoteConfigs();
}
function useValueOf(remoteConfigKey, fallback) {
  var _useContext5 = useContext(PFApplicationContext),
      client = _useContext5.client;

  return client === null || client === void 0 ? void 0 : client.valueOf(remoteConfigKey, fallback);
}
function useIdentify() {
  var _useContext6 = useContext(PFApplicationContext),
      client = _useContext6.client;

  return client === null || client === void 0 ? void 0 : client.identify.bind(client);
}
function useRefresh() {
  var _useContext7 = useContext(PFApplicationContext),
      client = _useContext7.client;

  return client === null || client === void 0 ? void 0 : client.refresh.bind(client);
}
function useIsReady() {
  var _useContext8 = useContext(PFApplicationContext),
      isReady = _useContext8.isReady;

  return isReady;
}
function useIsError() {
  var _useContext9 = useContext(PFApplicationContext),
      error = _useContext9.error;

  return [!!error, error];
}
/** @deprecated new method: useIsEnabled */

function useFlag(flag) {
  var _useContext10 = useContext(PFApplicationContext),
      client = _useContext10.client;

  return client === null || client === void 0 ? void 0 : client.isEnabled(flag);
}
/** @deprecated new method: useEvaluation */

function useFlags() {
  var _useContext11 = useContext(PFApplicationContext),
      client = _useContext11.client;

  return client === null || client === void 0 ? void 0 : client.releaseToggles();
}

/*
    <ReleaseToggle releaseToggleKey={'YOUR_KEY'} ifIsDisabled={() => <div>is OFF</div>}>
      <h1>Feature is ON!</h1>
    </ReleaseToggle>
*/

var ReleaseToggle = function ReleaseToggle(_ref) {
  var releaseToggleKey = _ref.releaseToggleKey,
      children = _ref.children;
  return useIsEnabled(releaseToggleKey) ? React.createElement(React.Fragment, null, children) : React.createElement(React.Fragment, null);
}; // Deprecated

var ReleaseFeature = function ReleaseFeature(_ref2) {
  var flagKey = _ref2.flagKey,
      children = _ref2.children;
  return useFlag(flagKey) ? React.createElement(React.Fragment, null, children) : React.createElement(React.Fragment, null);
};

export { KProvider, PFApplicationContext, ReleaseFeature, ReleaseToggle, useEvaluation, useFlag, useFlags, useIdentify, useIsEnabled, useIsError, useIsReady, useRefresh, useReleaseToggles, useRemoteConfigs, useValueOf };
